import { Theme } from '@mui/material';

// Creates the theme object for Nivo Funnel chart.
export const getFunnelChartTheme = (theme: Theme) => {
  const isLightTheme = theme.palette.mode === 'light';

  const labelColor =
    theme.blox?.colors?.offwhite ??
    (isLightTheme ? theme.blox?.colors?.offwhite : theme.blox?.colors?.offblack);

  const tooltipColor =
    theme.blox?.colors?.offblack ??
    (isLightTheme ? theme.blox?.colors?.offblack : theme.blox?.colors?.offwhite);

  const axisLineColor =
    theme.blox?.colors?.gray3 ??
    (isLightTheme ? theme.blox?.colors?.gray3 : theme.blox?.colors?.gray5);

  const tooltipBackground =
    theme.blox?.colors?.offwhite ??
    (isLightTheme ? theme.blox?.colors?.offwhite : theme.blox?.colors?.darkgray);

  const fontSize = 16;
  const fontWeight = 600;

  const funnelTheme = {
    background: 'transparent',
    text: {
      fontSize,
      fontWeight,
      fill: labelColor,
      outlineWidth: 0,
      outlineColor: 'transparent',
    },
    axis: {
      domain: {
        line: {
          stroke: axisLineColor,
          strokeWidth: 1,
        },
      },
      legend: {
        text: {
          fill: labelColor,
          outlineWidth: 0,
          outlineColor: 'transparent',
        },
      },
      ticks: {
        line: {
          stroke: axisLineColor,
          strokeWidth: 1,
        },
        text: {
          fill: labelColor,
          outlineWidth: 0,
          outlineColor: 'transparent',
        },
      },
    },
    grid: {
      line: {
        stroke: '#dddddd',
        strokeWidth: 1,
      },
    },
    legends: {
      title: {
        text: {
          fill: labelColor,
          outlineWidth: 0,
          outlineColor: 'transparent',
        },
      },
      text: {
        fill: labelColor,
        outlineWidth: 0,
        outlineColor: 'transparent',
      },
      ticks: {
        line: {},
        text: {
          fill: labelColor,
          outlineWidth: 0,
          outlineColor: 'transparent',
        },
      },
    },
    annotations: {
      text: {
        fill: labelColor,
        outlineWidth: 2,
        outlineColor: 'green',
        outlineOpacity: 1,
      },
      link: {
        stroke: theme.blox?.colors?.yellow,
        strokeWidth: 1,
        outlineWidth: 2,
        outlineColor: 'green',
        outlineOpacity: 1,
      },
      outline: {
        stroke: '#000000',
        strokeWidth: 2,
        outlineWidth: 2,
        outlineColor: 'green',
        outlineOpacity: 1,
      },
      symbol: {
        fill: '#000000',
        outlineWidth: 2,
        outlineColor: 'green',
        outlineOpacity: 1,
      },
    },
    tooltip: {
      wrapper: {
        zIndex: 9999,
      },
      container: {
        background: tooltipBackground,
        color: tooltipColor,
        fontSize,
        zIndex: 9999,
      },
      basic: {},
      chip: {
        zIndex: 9999,
      },
      table: {},
      tableCell: {},
      tableCellValue: {},
    },
  };

  return funnelTheme;
};

export const formatFunnelValue = (
  label: string,
  value: number,
  isNailShape: boolean,
  showValue: boolean = true,
) => {
  const val = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 1,
    notation: 'compact',
  }).format(value);

  if (!isNailShape) {
    return label;
  }

  return showValue ? `${label}: ${val}` : label;
};
